import { Badge } from '@components/ui/badge';
import { DashboardItemPillProps } from './types';
import { cn } from '@utils/cn';
import { variants } from './constants';
import { AppTooltip } from '@components/ui/tooltip/tooltip';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export const DashboardItemPill = ({
  children,
  variant = 'default',
  size = 'lg',
  className,
}: DashboardItemPillProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'pages.workflows.task' });

  const withTooltip = (component: ReactNode) => {
    if (variant !== 'warning') return component;
    return (
      <AppTooltip context={t('specialtyWarning')}>
        <div>{component}</div>
      </AppTooltip>
    );
  };

  return withTooltip(
    <Badge
      variant={null}
      className={cn(
        'flex items-center justify-center whitespace-nowrap border-none',
        size === 'lg'
          ? 'px-4 text-s font-semibold leading-none'
          : 'px-3 text-xs font-medium leading-none',
        variants[variant],
        className || 'h-fit py-1.5',
      )}>
      {children}
    </Badge>,
  );
};
